const IMAGE_SERVER_URL = import.meta.env.VITE_IMAGE_SERVER_URL;

// ==========================================================
// IMAGE URL
// Backend stores: /photo/tims/inventory/example.png
// Browser needs: http://192.168.1.200:8050/photo/...
// ==========================================================
export const getImageUrl = (imageUrl) => {
    if (!imageUrl) {
        return "";
    }

    if (imageUrl.startsWith("http://") ||
        imageUrl.startsWith("https://") ||
        imageUrl.startsWith("blob:")
    ) {
        return imageUrl;
    }

    return `${IMAGE_SERVER_URL}${imageUrl}`;
};